// Converte qualquer lastActiveAt em Date de forma segura
export function normalizeTimestamp(value) {
  if (!value) return null;

  // Caso Firestore Timestamp
  if (typeof value.toDate === "function") {
    return value.toDate();
  }

  // Caso string ISO ou Y-M-D
  if (typeof value === "string") {
    const d = new Date(value);
    if (!isNaN(d.getTime())) return d;
  }

  // Caso número (timestamp unix)
  if (typeof value === "number") {
    return new Date(value);
  }

  return null;
}
